import React from 'react';
import image from '../Image/1960-20210430210008248.jpg'

const About = () => {
    return (
        <div class="hero mt-24 ">
            <div class="hero-content flex-col lg:flex-row">
                <img src={image} class="max-w-sm rounded-lg " />
                <div className='w-96'>
                    <h1 class="text-5xl font-bold text-center">About Me</h1>
                    <p class="py-6 ml-12 text center text-xl">Solution-focused Web Developer Intern with experience in web-based applications. Participated in development and implementation of web-based solutions. Supported company business objectives and strategies while gaining real-world experience. learning multiple systems and efficient development techniques.</p>
                </div>
            </div>
        </div>
    );
};

export default About;